import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppSettings } from '../app.settings';
import { Store } from '@ngxs/store';
import { GiftActions } from '../transaction-store/gift';
import { HelperService } from '../shared/helper.service';

@Component({
  selector: 'app-gift',
  template: `
    <section class="container">
      <div class="row">
        <h2 class="section-title col">Your Gift</h2>
      </div>
      <div class="row">
        <div class="col-sm-5 gift-btn">
          <button
            *ngIf="!selectedGift"
            type="button"
            class="btn btn-outline-secondary w-100"
            (click)="open(content)"
            aria-label="Select your gift"
          >
            Select Your Gift
          </button>
          <div
            *ngIf="selectedGift"
            (click)="open(content)"
            class="choose-type-image h-100"
            [ngStyle]="{
              'background-image': 'url(' + selectedGift.image_url + ')'
            }"
          ></div>
        </div>
      </div>
    </section>
    <ng-template #content let-c="close" let-d="dismiss">
      <div class="modal-header d-block text-center container">
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="d('Cross click')"
        >
          <span aria-hidden="true" aria-label="Close modal">&times;</span>
        </button>
        <div class="row">
          <h2 id="modalGiftTitle" class="col-12">Choose Your Thank You Gift</h2>
          <p class="col-12">
            To say thank you for your donation, <br />choose from one of the
            gifts below.
          </p>
        </div>
      </div>
      <div class="modal-body container">
        <div class="row text-center">
          <div
            class="col-12 col-sm choose-type align-center text-center"
            *ngFor="let item of giftList"
          >
            <label
              class="h-100"
              tabindex="0"
              role="button"
              [ngClass]="item.id == selected ? 'active-gift' : ''"
            >
              <div
                class="choose-type-image h-100"
                [ngStyle]="{
                  'background-image': 'url(' + item.image_url + ')'
                }"
              ></div>
              <p class="text-center choose-type-title">
                {{ item.description }}
              </p>
              <input
                type="radio"
                name="gift"
                [value]="item.id"
                id="gift"
                hidden
                [(ngModel)]="selected"
                (ngModelChange)="setGift(item)"
              />
            </label>
          </div>
        </div>
        <div class="row" *ngIf="selectedGift && selectedGift.extra_placeholder">
          <h3 class="col-12 text-center">Additional Gift Info</h3>
          <text-field
            class="col text-center"
            [label]="selectedGift.extra_placeholder"
            (blur)="setExtra($event)"
          ></text-field>
        </div>
        <div class="row">
          <div class="col text-center form-group">
            <button
              type="submit"
              class="btn btn-primary"
              (click)="give(); c()"
              [disabled]="!selected"
              aria-label="Continue"
            >
              Continue
            </button>
            <span id="thankyou-skip"
              >&nbsp;&nbsp;&nbsp;or
              <a (click)="skip(); d()" aria-label="Skip my gift">
                <strong>skip my gift</strong></a
              >
            </span>
          </div>
        </div>
      </div>
    </ng-template>
  `
})
export class GiftComponent {
  closeResult: string;
  giftList;
  selected = null;
  showPlaceholder = false;
  selectedGift = null;

  constructor(
    private modalService: NgbModal,
    private settings: AppSettings,
    private store: Store,
    private helper: HelperService
  ) {
    this.giftList = this.settings.getValue('organization').campaign.gifts;
  }
  open(content) {
    this.helper.repositionModal('.gift-btn');
    this.modalService.open(content, { size: 'lg' }).result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      () => {
        this.closeResult = `Dismissed`;
      }
    );
  }
  setGift(item) {
    this.selectedGift = item;
    this.store.dispatch(new GiftActions.SetGiftID(item.id));
  }
  skip() {
    this.selectedGift = null;
    this.selected = null;
    this.store.dispatch(new GiftActions.SetGiftCompleted(false));
  }
  give() {
    this.store.dispatch(new GiftActions.SetGiftCompleted(true));
  }
  setExtra($event) {
    this.store.dispatch(new GiftActions.SetGiftExtra($event));
  }
}
